import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LoreScreen.module.css';
import LoreChapter from '../components/Lore/LoreChapter';

const CHAPTER_COLORS = [
  { color: '#e8306a', glow: 'rgba(232, 48, 106, 0.3)' },
  { color: '#f5a623', glow: 'rgba(245, 166, 35, 0.25)' },
  { color: '#a78bfa', glow: 'rgba(167, 139, 250, 0.28)' },
  { color: '#3ecfb2', glow: 'rgba(62, 207, 178, 0.3)' },
];

export default function LoreScreen() {
  const { t } = useTranslation();
  const loreData = t('lore', { returnObjects: true });
  const chapters = loreData.chapters || [];
  
  const [active, setActive]       = useState(0);
  const [animating, setAnimating] = useState(false);
  const [visible, setVisible]     = useState(false);
  const sectionRef                = useRef(null);

  const chapter = chapters[active] || {};
  const chapterColor = CHAPTER_COLORS[active] || CHAPTER_COLORS[0];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const goTo = (i) => {
    if (i === active || animating || i < 0 || i >= chapters.length) return;
    setAnimating(true);
    setTimeout(() => {
      setActive(i);
      setAnimating(false);
    }, 320);
  };

  return (
    <section
      ref={sectionRef}
      className={`${styles.hero}${visible ? ` ${styles.visible}` : ''}`}
      style={{ '--chapter-color': chapterColor.color }}
    >
      <LoreChapter 
        chapter={chapter}
        chapterColor={chapterColor}
        animating={animating}
        chapters={chapters}
        active={active}
        onNavigate={goTo}
        label={loreData.label}
        visible={visible}
        chapterColors={CHAPTER_COLORS}
      />
      
      <div className={styles.credits}>
        <p>
          Lore infographic by{' '}
          <a href="https://www.reddit.com/r/SleepToken/comments/1iu1pch/sleeps_vessel_lore_infographic/" target="_blank" rel="noopener noreferrer">
            @_smile_co_
          </a>
        </p>
      </div>
    </section>
  );
}